export const NAV_BAR_HEIGHT = 'var(--uicomponents-global-nav-height, 54px)';